import { createLucideIcon } from 'lucide-react-native'

// lucide has no yen-in-a-circle; this is its JapaneseYen glyph scaled by 0.6 inside a circle, to match the
// SF Symbol yensign.circle used by the native tab bar.
const CircleJapaneseYenIcon = createLucideIcon('CircleJapaneseYen', [
  ['circle', { cx: '12', cy: '12', r: '10', key: 'circle' }],
  ['path', { d: 'M12 10.5V17.4m0-6.9L8.4 6.6m3.6 3.9 3.6-3.9', key: 'stem' }],
  ['path', { d: 'M8.4 13.8h7.2', key: 'lower-bar' }],
  ['path', { d: 'M8.4 11.4h7.2', key: 'upper-bar' }],
])

export default CircleJapaneseYenIcon
